import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { MenuItem, Chip } from "@material-ui/core";

import InputForm from "./inputForm";
const styles = (theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
    margin: -theme.spacing(0.5),
  },
  chip: {
    margin: theme.spacing(0.5),
    zIndex: 999,
  },
  selectMenu: {
    minHeight: theme.spacing(7),
    boxSizing: "border-box",
  },
  menuItem: {
    color: "#292f48",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    "&:hover": {
      backgroundColor: "transparent !important",
    },
  },
  selected: {
    backgroundColor: "transparent !important",
  },
});

class SelectMultipleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }
  getLabel = (value = "") => {
    const { list = [] } = this.props;
    let find = list.find((e) => e.value === value);
    if (find) return find.label;
    return value;
  };
  removeChip = (value) => (event) => {
    const { name } = this.props;
    let filter = (this.props.value || []).filter((e) => e !== value);
    this.props.onChange({
      target: {
        name: name,
        value: filter,
      },
    });
  };
  handleChange = (e, child) => {
    this.onClose();
    let { target } = e;
    this.props.onChange({
      ...e,
      target: target,
    });
  };
  onClose = () => {
    this.setState({ open: false });
  };
  onOpen = () => {
    this.setState({ open: true });
  };
  render() {
    const { open = false } = this.state;
    const { classes, list = [], name, ...props } = this.props;
    return (
      <InputForm
        {...props}
        name={name}
        select
        multiple={true}
        type="array"
        onChange={this.handleChange}
        SelectProps={{
          displayEmpty: true,
          open: open,
          onClose: this.onClose,
          onOpen: this.onOpen,
          multiple: true,
          classes: {
            selectMenu: classes.selectMenu,
          },
          renderValue: (selected) => {
            return (
              <div
                className={classes.chips}
                style={
                  selected && selected.length
                    ? { marginTop: -12, marginBottom: -12 }
                    : {}
                }
              >
                {selected.map((value) => {
                  return (
                    <Chip
                      key={`#${name}-${value}`}
                      label={this.getLabel(value)}
                      className={classes.chip}
                      // onDelete={this.removeChip(value)}
                    />
                  );
                })}
              </div>
            );
          },
        }}
      >
        {list.map((e, i) => {
          return (
            <MenuItem
              key={`${e.value}-${i}`}
              value={e.value}
              classes={{
                selected: classes.selected,
                root: classes.menuItem,
              }}
            >
              {e.label}
            </MenuItem>
          );
        })}
      </InputForm>
    );
  }
}

SelectMultipleForm.propTypes = {
  // onChange: PropTypes.func.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SelectMultipleForm)
  )
);
